import { useMemo } from "react";
import { EMPTY_ARRAY, EMPTY_BY_GROUP } from "../useGroupSelectionV3/constants";
import { countElementsByRoom, scopeElementsToRooms } from "../../utils/rooms";
import type { UseRoomScopedPlanElements } from "./types";

// Exports and the rooms list read this all-rooms scope, so stepping into one room never narrows them
export const useRoomScopedPlanElements: UseRoomScopedPlanElements = ({
  selectedPlan,
  rooms,
}) => {
  const planGroupIds = selectedPlan?.groupedElements?.groupIds ?? EMPTY_ARRAY;
  const planByGroupId =
    selectedPlan?.groupedElements?.byGroupId ?? EMPTY_BY_GROUP;

  const { groupIds, byGroupId } = useMemo(
    () =>
      scopeElementsToRooms({
        groupIds: planGroupIds,
        byGroupId: planByGroupId,
        rooms,
      }),
    [planGroupIds, planByGroupId, rooms],
  );

  const roomElementCounts = useMemo(
    () => countElementsByRoom({ rooms, groupIds, byGroupId }),
    [rooms, groupIds, byGroupId],
  );

  return { groupIds, byGroupId, roomElementCounts };
};
